import gql from "graphql-tag";

export const GET_USER_NOTIFICATION_TYPES_QUERY = gql`
  query {
    getUserNotificationTypes {
      types {
        title
        type
      }
    }
  }
`;
